module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/students-experience-716b554fb53eb9d6d5d5fa8b242ce9b2.png";